import { connect } from "react-redux";
import Roles from "./Roles";
import {
  updatePermissionLoading,
  roles,
  permissions,
  saveRoleLoading,
  rolesPagination,
  getError,
  rolesLoading,
} from "../../store/selectors/user.selector";
import {
  getRoles,
  createRoleRequest,
  updateRoleRequest,
  deleteRoleRequest,
  updaterolePermissions,
  getPermissionsRequest,
} from "../../store/actions/user.actions";

const mapDispatchToProps = {
  getRolesRequest: getRoles,
  getPermissionsRequest,
  createRoleRequest,
  updateRoleRequest,
  deleteRoleRequest,
  updaterolePermissions,
};

const mapStateToProps = (state) => {
  const permissionLoading = updatePermissionLoading(state);
  const allRoles = roles(state);
  const loading = rolesLoading(state);
  const pagination = rolesPagination(state);
  const allPermissions = permissions(state);
  const roleLoading = saveRoleLoading(state);
  const error = getError(state);

  return {
    error,
    loading,
    roleLoading,
    pagination,
    permissionLoading,
    allRoles,
    allPermissions,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Roles);
